module.exports = __webpack_public_path__ + "img/add-image13.8416f856.png";